/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import styles from 'bundles/common/components/__styles__/NotFoundSvg';

const NotFoundSvg = () => (
  <div css={styles.svgContainer}>
    <svg
      min-width="380px"
      width="100%"
      height="100%"
      viewBox="0 0 596 367"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Illustration">
        <g id="Discovery Center">
          <mask id="mask0_61_1843" maskUnits="userSpaceOnUse" x="28" y="0" width="568" height="367">
            <path
              id="Black background mask"
              d="M595.182 354.932C595.182 361.597 589.779 367 583.114 367L184.17 367C97.9201 367 28.0002 297.08 28.0002 210.83L28.0002 12.0677C28.0002 5.40286 33.4031 -1.85947e-05 40.0679 -1.8012e-05L583.114 2.94626e-05C589.779 3.00452e-05 595.182 5.40292 595.182 12.0677L595.182 354.932Z"
              fill="black"
            />
          </mask>
          <g>
            <path
              id="Black background"
              d="M595.182 354.932C595.182 361.597 589.779 367 583.114 367L184.17 367C97.9201 367 28.0002 297.08 28.0002 210.83L28.0002 12.0677C28.0002 5.40286 33.4031 -1.85947e-05 40.0679 -1.8012e-05L583.114 2.94626e-05C589.779 3.00452e-05 595.182 5.40292 595.182 12.0677L595.182 354.932Z"
              fill="black"
            />
            <g id="Top Dinosaur">
              <path
                id="Vector 32"
                d="M338.539 82.7804C337.474 84.0254 336.062 85.0963 334.707 85.9368C333.266 86.8307 332.976 89.1157 334.074 90.4084C336.234 92.9521 337.545 95.9187 338.226 98.1475C338.574 99.2853 339.701 100.087 340.825 99.695C345.639 98.0146 349.534 93.8852 351.321 91.3982C351.586 91.0293 351.711 90.5764 351.651 90.1261C350.866 84.2158 344.456 82.2517 340.392 81.9142C339.673 81.8545 339.008 82.2322 338.539 82.7804Z"
                fill="var(--cds-color-yellow-200)"
              />
              <g id="Vector 28">
                <path
                  d="M216.301 144.441L212.903 134.495C212.523 133.382 213.117 132.171 214.23 131.791L220.501 129.649C220.887 129.517 221.226 129.278 221.48 128.959L224.472 125.196C225.113 124.39 226.237 124.153 227.128 124.669C234.332 128.841 244.552 136.859 237.445 141.473C230.548 145.95 222.234 146.281 217.94 145.801C217.173 145.715 216.55 145.171 216.301 144.441Z"
                  fill="var(--cds-color-yellow-200)"
                />
                <path
                  d="M247.017 136.622C244.674 127.917 238.255 121.802 234.299 119.115C233.557 118.611 233.144 117.738 233.247 116.847C235.826 94.5398 211.522 63.1282 195.574 46.5034C194.178 45.0476 195.314 42.8547 197.217 43.5221C220.08 51.5371 240.55 90.7226 248.812 111.739C249.075 112.406 249.648 112.866 250.302 113.16C256.884 116.111 268.298 132.693 263.048 134.487C257.014 136.548 252.862 138.276 248.862 138.199C247.962 138.182 247.251 137.491 247.017 136.622Z"
                  fill="var(--cds-color-yellow-200)"
                />
              </g>
              <path
                id="Vector 29"
                d="M273.1 128.215C271.044 120.681 265.109 115.508 261.257 113.167C260.409 112.652 259.944 111.668 260.095 110.687C263.219 90.511 240.521 63.3713 225.167 48.8272C223.697 47.4343 224.727 45.1473 226.673 45.7087C249.262 52.2254 268.284 86.7886 275.844 105.592C276.126 106.292 276.752 106.765 277.455 107.039C283.983 109.58 294.723 124.1 289.394 125.92C283.292 128.005 279.066 129.721 275.072 129.83C274.12 129.856 273.351 129.133 273.1 128.215Z"
                fill="var(--cds-color-yellow-200)"
              />
              <path
                id="Vector 30"
                d="M298.436 119.601C296.55 112.826 290.963 108.246 287.2 106.127C286.277 105.608 285.773 104.543 285.961 103.501C289.355 84.7264 267.782 60.3068 252.856 47.0942C251.332 45.745 252.301 43.4019 254.275 43.8972C276.6 49.4981 294.658 81.0748 301.763 98.4449C302.058 99.1654 302.719 99.6452 303.453 99.9029C309.928 102.175 320.222 115.39 314.857 117.223C308.733 119.315 304.473 121.02 300.493 121.241C299.507 121.296 298.7 120.552 298.436 119.601Z"
                fill="var(--cds-color-yellow-200)"
              />
              <path
                id="Vector 31"
                d="M319.883 104.462C318.476 100.03 314.86 96.9625 312.187 95.3886C311.26 94.8426 310.749 93.7567 310.915 92.6936C312.957 79.5624 298.564 62.965 287.773 53.2993C286.254 51.9392 287.212 49.6562 289.156 50.2714C304.837 55.2347 317.342 76.8049 322.46 89.1122C322.761 89.8364 323.432 90.3266 324.16 90.6176C328.969 92.5391 336.149 101.762 332.237 103.099C327.905 104.579 324.823 105.795 321.989 106.07C320.998 106.166 320.184 105.411 319.883 104.462Z"
                fill="var(--cds-color-yellow-200)"
              />
              <path
                id="Exclude"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M187.765 158.84C199.417 158.241 207.041 152.58 210.142 149.033C210.678 148.42 210.722 147.539 210.331 146.824L203.409 134.16C203.251 133.871 203.162 133.534 203.147 133.206C201.688 100.939 182.475 107.503 176.221 109.639C169.934 111.787 163.124 114.113 154.527 111.21C147.649 108.888 135.953 116.777 130.964 121.012L97.871 144.454C97.6398 144.618 97.4478 144.82 97.2963 145.059C92.9811 151.878 82.1799 165.836 71.6143 169.905C62.4862 173.42 59.559 182.419 59.0481 188.336C58.9264 189.746 60.3173 190.7 61.6566 190.243L78.7005 184.42C79.1627 184.262 79.6652 184.268 80.1237 184.436L89.3985 187.846C89.8646 188.017 90.3636 188.025 90.8316 187.859C106.762 182.212 139.124 170.538 146.687 167.034C156.283 162.587 171.667 159.668 187.765 158.84ZM108.971 150.82C106.961 143.564 126.905 128.536 137.128 121.928C144.702 116.699 150.476 128.464 148.75 131.974C148.147 133.201 148.638 134.91 149.235 136.99C150.346 140.861 151.826 146.017 147.312 151.738C140.371 160.533 111.485 159.889 108.971 150.82ZM75.1208 169.748C75.218 172.292 76.4801 176.777 80.7509 174.367C85.0216 171.956 90.1086 161.655 92.1183 156.805L75.1208 169.748Z"
                fill="var(--cds-color-yellow-200)"
              />
            </g>
            <g id="BottomDinosaur">
              <path
                id="Vector 32_2"
                d="M383.075 337.287C384.38 338.278 385.987 339.025 387.489 339.559C389.087 340.127 389.855 342.299 389.056 343.795C387.484 346.739 386.832 349.916 386.639 352.238C386.54 353.424 385.609 354.447 384.428 354.302C379.366 353.68 374.684 350.47 372.411 348.419C372.074 348.115 371.855 347.698 371.818 347.246C371.332 341.303 377.18 338.025 381.081 336.833C381.771 336.622 382.5 336.851 383.075 337.287Z"
                fill="var(--cds-color-yellow-200)"
              />
              <g id="Vector 28_2">
                <path
                  d="M515.607 371.629L516.819 361.189C516.955 360.021 516.117 358.964 514.949 358.828L508.366 358.064C507.962 358.017 507.579 357.855 507.264 357.597L503.542 354.554C502.745 353.903 501.595 353.91 500.834 354.602C494.678 360.207 486.39 370.209 494.314 373.211C502.004 376.125 510.2 374.686 514.294 373.306C515.025 373.06 515.518 372.395 515.607 371.629Z"
                  fill="var(--cds-color-yellow-200)"
                />
                <path
                  d="M483.931 370.5C484.376 361.496 489.352 354.159 492.649 350.695C493.268 350.045 493.486 349.105 493.196 348.256C485.946 327.002 503.038 291.152 515.098 271.524C516.154 269.805 514.579 267.903 512.86 268.959C492.217 281.639 480.521 324.273 476.902 346.564C476.787 347.272 476.324 347.843 475.747 348.268C469.941 352.548 462.302 371.173 467.813 371.813C474.147 372.548 478.57 373.356 482.463 372.433C483.339 372.225 483.887 371.399 483.931 370.5Z"
                  fill="var(--cds-color-yellow-200)"
                />
              </g>
              <path
                id="Vector 29_2"
                d="M456.659 367.814C457.071 360.016 461.775 353.702 465.043 350.597C465.762 349.914 466.008 348.854 465.652 347.928C458.322 328.873 474.75 297.538 486.671 280.069C487.813 278.396 486.321 276.38 484.538 277.341C463.844 288.498 452.583 326.309 449.181 346.288C449.054 347.032 448.543 347.627 447.913 348.043C442.073 351.91 434.655 368.377 440.25 369.027C446.654 369.77 451.148 370.551 455.075 369.811C456.011 369.635 456.609 368.765 456.659 367.814Z"
                fill="var(--cds-color-yellow-200)"
              />
              <path
                id="Vector 30_2"
                d="M430.073 364.768C430.48 357.747 434.968 352.086 438.197 349.218C438.989 348.515 439.256 347.368 438.851 346.389C431.553 328.761 447.459 300.323 459.244 284.246C460.447 282.604 459.004 280.52 457.179 281.423C436.55 291.629 425.597 326.317 422.336 344.798C422.2 345.565 421.656 346.174 420.993 346.582C415.148 350.174 407.89 365.272 413.521 365.926C419.949 366.672 424.474 367.434 428.411 366.807C429.385 366.652 430.016 365.754 430.073 364.768Z"
                fill="var(--cds-color-yellow-200)"
              />
              <path
                id="Vector 31_2"
                d="M405.904 354.52C406.339 349.89 409.222 346.126 411.501 344.022C412.291 343.291 412.56 342.122 412.173 341.118C407.393 328.718 417.94 309.447 426.437 297.713C427.632 296.062 426.212 294.034 424.443 295.047C410.17 303.222 402.524 326.953 400.131 340.066C399.991 340.837 399.438 341.459 398.788 341.897C394.496 344.795 389.436 355.331 393.541 355.807C398.089 356.335 401.359 356.871 404.187 356.538C405.176 356.422 405.811 355.511 405.904 354.52Z"
                fill="var(--cds-color-yellow-200)"
              />
              <path
                id="Exclude_2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M546.548 379.651C535.033 381.536 526.382 377.62 522.6 374.811C521.946 374.326 521.716 373.474 521.946 372.693L526.026 358.849C526.119 358.533 526.135 358.185 526.08 357.861C520.665 326.018 540.833 328.359 547.397 329.121C553.996 329.887 561.145 330.717 568.931 326.057C575.16 322.329 588.264 327.559 594.036 330.641L631.347 346.533C631.608 346.644 631.839 346.801 632.037 347.003C637.7 352.751 651.215 364.102 662.403 365.838C672.069 367.338 676.838 375.512 678.591 381.186C679.009 382.538 677.852 383.766 676.447 383.603L658.556 381.526C658.07 381.47 657.581 381.582 657.168 381.844L648.827 387.142C648.408 387.408 647.922 387.521 647.429 387.458C630.664 385.318 596.562 380.77 588.429 378.949C578.108 376.638 562.455 377.047 546.548 379.651ZM621.849 355.108C622.276 347.591 599.599 337.132 588.208 332.843C579.697 329.338 576.548 342.06 578.979 345.124C579.829 346.195 579.712 347.969 579.569 350.129C579.304 354.148 578.951 359.5 584.575 364.133C593.223 371.257 621.316 364.504 621.849 355.108ZM658.943 366.429C659.388 368.936 659.105 373.586 654.42 372.136C649.736 370.686 642.58 361.697 639.588 357.384L658.943 366.429Z"
                fill="var(--cds-color-yellow-200)"
              />
            </g>
            <path
              id="Large pink blob"
              d="M52.0002 363.423C52.0002 363.423 57.4084 344.003 75.1782 339.342C92.948 334.681 112.263 351.771 118.444 339.342C124.624 326.912 112.263 296.616 130.033 302.831C147.802 309.045 135.441 342.449 150.893 347.11C166.345 351.771 165.572 367.308 165.572 367.308H52.1393L52.0002 363.423Z"
              fill="var(--cds-color-pink-300)"
            />
            <path
              id="Med blue bush"
              d="M215 369C215 369 228.886 366.823 234.728 361.007C240.569 355.191 247.886 369 250.817 364.638C253.748 360.276 252.279 349.382 254.476 350.836C256.673 352.29 260.303 364.638 264.668 360.256C269.034 355.873 259.877 345.201 269.216 334.926C269.216 334.926 274.483 365.654 297.345 368.77L215 369Z"
              fill="var(--cds-color-blue-100)"
            />
            <path
              id="Small blue blob"
              d="M62.6576 275.079H89.0424C89.0424 275.079 95.492 267.47 89.6287 268.055C83.7654 268.64 77.0226 270.396 79.368 266.299C81.7133 262.202 93.4398 253.421 85.8176 254.007C78.1953 254.592 72.9183 259.86 72.332 262.787C71.7457 265.714 68.2277 261.323 64.7097 261.909C61.1918 262.494 62.0713 265.421 64.7097 268.055C67.3482 270.689 56.208 269.811 62.6576 275.079Z"
              fill="var(--cds-color-blue-100)"
            />
            <path
              id="Small pink bush"
              d="M427.852 15.617C427.852 15.617 421.41 18.6913 420.758 23.5672C420.107 28.4431 417.501 21.6162 413.59 22.5902C409.678 23.5641 411.635 30.7177 406.751 28.7667C401.867 26.8157 397.311 30.391 391.451 33.6426H442.242C442.242 33.6426 431.044 33.0172 427.852 15.617Z"
              fill="var(--cds-color-pink-300)"
            />
            <path
              id="Med pink blob"
              d="M582.983 163.765C584.588 164.294 617.923 163.765 617.923 163.765C617.923 163.765 619.368 154.231 609.737 151.583C600.105 148.935 601.71 149.464 601.175 136.223C600.64 122.982 597.965 102.326 589.939 112.919C581.912 123.512 586.193 136.223 578.702 142.579C571.211 148.935 568 152.113 568 163.765H582.983Z"
              fill="var(--cds-color-pink-300)"
            />
          </g>
        </g>
        <g id="Ladder Square">
          <path
            id="Blue Square"
            d="M309.688 154.841L437.947 228.931L307.687 306.307L177.427 228.931L305.686 154.841C306.924 154.126 308.45 154.126 309.688 154.841Z"
            fill="var(--cds-color-blue-600)"
          />
          <path
            id="Magenta Diamond"
            d="M306.361 304.758L168.426 224.063C166.446 222.905 166.446 220.043 168.426 218.884L305.367 138.772C307.238 137.677 309.553 137.677 311.424 138.771L417.36 200.691L445.193 217.997C447.741 219.581 447.702 223.303 445.122 224.834L310.422 304.745C309.171 305.487 307.617 305.492 306.361 304.758Z"
            stroke="var(--cds-color-pink-300)"
            strokeWidth="2.83946"
            strokeLinecap="square"
          />
          <mask id="mask1_61_1843" maskUnits="userSpaceOnUse" x="164" y="58" width="289" height="247">
            <path
              id="Ladder Mask"
              d="M308.5 304.5L164 219.5V58H453V218.5L308.5 304.5Z"
              fill="var(--cds-color-grey-100)"
            />
          </mask>
          <g mask="url(#mask1_61_1843)">
            <g id="Full ladder">
              <g id="Ladder">
                <path
                  id="Vector 34"
                  d="M353.073 67.6617L269.354 283.295L290.107 296.014L375.834 75.6947V64.984L361.776 59.6287L353.073 67.6617Z"
                  fill="white"
                  stroke="black"
                  strokeWidth="2.12959"
                  strokeLinecap="round"
                />
                <path
                  id="Vector 36"
                  d="M353.635 111.418C352.442 110.74 350.926 111.158 350.248 112.351C349.57 113.545 349.988 115.061 351.181 115.739L353.635 111.418ZM408.68 148.393L410.841 149.62L413.295 145.299L411.134 144.072L408.68 148.393ZM351.181 115.739L408.68 148.393L411.134 144.072L353.635 111.418L351.181 115.739Z"
                  fill="white"
                />
                <path
                  id="Vector 37"
                  d="M338.709 153.289C337.509 152.622 335.997 153.054 335.33 154.253C334.663 155.452 335.095 156.965 336.294 157.632L338.709 153.289ZM391.663 188.866L393.835 190.073L396.249 185.73L394.078 184.523L391.663 188.866ZM336.294 157.632C347.484 163.854 355.716 168.542 363.956 173.236C372.198 177.931 380.449 182.631 391.663 188.866L394.078 184.523C382.888 178.301 374.656 173.612 366.416 168.919C358.174 164.224 349.923 159.524 338.709 153.289L336.294 157.632Z"
                  fill="white"
                />
                <path
                  id="Vector 38"
                  d="M323.146 193.073C321.964 192.376 320.441 192.769 319.744 193.951C319.047 195.133 319.44 196.656 320.622 197.353L323.146 193.073ZM375.992 230.007L378.132 231.269L380.656 226.989L378.516 225.727L375.992 230.007ZM320.622 197.353L348.307 213.68L350.831 209.4L323.146 193.073L320.622 197.353ZM348.307 213.68L375.992 230.007L378.516 225.727L350.831 209.4L348.307 213.68Z"
                  fill="white"
                />
                <path
                  id="Vector 39"
                  d="M305.344 233.503C304.145 232.837 302.632 233.269 301.966 234.469C301.299 235.668 301.732 237.181 302.931 237.847L305.344 233.503ZM360.43 269.791L362.602 270.997L365.015 266.654L362.843 265.447L360.43 269.791ZM304.138 235.675C302.931 237.847 302.931 237.847 302.931 237.847C302.931 237.847 302.932 237.847 302.932 237.847C302.932 237.848 302.933 237.848 302.934 237.849C302.936 237.85 302.939 237.852 302.944 237.854C302.952 237.859 302.965 237.866 302.982 237.875C303.015 237.894 303.065 237.921 303.131 237.958C303.262 238.031 303.455 238.138 303.706 238.277C304.207 238.556 304.935 238.96 305.844 239.465C307.662 240.476 310.204 241.887 313.096 243.494C318.879 246.707 326.067 250.7 331.681 253.819L334.094 249.475C328.48 246.356 321.293 242.363 315.509 239.15C312.617 237.544 310.076 236.132 308.257 235.122C307.348 234.617 306.62 234.212 306.119 233.934C305.869 233.795 305.675 233.687 305.544 233.614C305.478 233.578 305.428 233.55 305.395 233.531C305.378 233.522 305.365 233.515 305.357 233.51C305.353 233.508 305.349 233.506 305.347 233.505C305.346 233.504 305.346 233.504 305.345 233.504C305.345 233.504 305.345 233.503 305.344 233.503C305.344 233.503 305.344 233.503 304.138 235.675ZM331.681 253.819C337.294 256.938 344.482 260.931 350.266 264.144C353.158 265.751 355.699 267.162 357.517 268.172C358.426 268.677 359.154 269.082 359.655 269.36C359.906 269.5 360.099 269.607 360.231 269.68C360.296 269.717 360.346 269.744 360.379 269.763C360.396 269.772 360.409 269.779 360.417 269.784C360.422 269.787 360.424 269.787 360.427 269.789C360.428 269.79 360.429 269.79 360.429 269.79C360.43 269.791 360.43 269.791 360.43 269.791C360.43 269.791 360.43 269.791 361.637 267.619C362.843 265.447 362.843 265.447 362.843 265.447C362.843 265.447 362.843 265.447 362.842 265.447C362.842 265.447 362.841 265.446 362.84 265.445C362.838 265.444 362.835 265.443 362.83 265.44C362.822 265.435 362.81 265.429 362.793 265.419C362.759 265.4 362.709 265.373 362.644 265.336C362.513 265.264 362.319 265.156 362.068 265.017C361.567 264.738 360.839 264.334 359.93 263.829C358.112 262.819 355.571 261.407 352.679 259.8C346.895 256.587 339.707 252.594 334.094 249.475L331.681 253.819Z"
                  fill="white"
                />
                <path
                  id="Vector 40"
                  d="M289.761 274.694C288.572 274.009 287.053 274.418 286.368 275.607C285.683 276.796 286.091 278.315 287.28 279L289.761 274.694ZM319.934 297.812L322.087 299.052L324.567 294.746L322.415 293.506L319.934 297.812ZM287.28 279L319.934 297.812L322.415 293.506L289.761 274.694L287.28 279Z"
                  fill="white"
                />
                <path
                  id="Vector 35"
                  d="M434.876 102.93L426.163 110.948L363.056 273.298L396.675 253.144L448.95 118.965V108.275L434.876 102.93Z"
                  fill="white"
                  stroke="black"
                  strokeWidth="2.12959"
                  strokeLinecap="round"
                />
                <ellipse id="Ellipse 17" cx="423.75" cy="152.266" rx="3.19439" ry="4.61412" fill="black" />
                <ellipse id="Ellipse 18" cx="406.713" cy="193.438" rx="3.19439" ry="4.61412" fill="black" />
                <ellipse id="Ellipse 19" cx="390.386" cy="234.61" rx="3.19439" ry="4.61412" fill="black" />
              </g>
            </g>
          </g>
        </g>
        <path
          className="sparkle"
          id="large-blue-shine"
          d="M538.786 85.1768L539.386 51L551.97 86.9756L574.141 78.5813L557.962 94.1708L550.771 112.758L548.374 98.3679L528 99.5671L538.786 85.1768Z"
          fill="var(--cds-color-blue-100)"
        />
        <path
          className="sparkle"
          id="small-blue-shine"
          d="M175.04 55.7634L165 50L173.032 57.8085L170.841 65.617L174.857 59.6676L184.167 61.8987L177.595 57.4366L182.341 51.1155L175.04 55.7634Z"
          fill="var(--cds-color-blue-100)"
        />
        <path
          className="sparkle"
          id="small-pink-shine"
          d="M536.04 180.763L526 175L534.032 182.808L531.841 190.617L535.857 184.668L545.167 186.899L538.595 182.437L543.341 176.115L536.04 180.763Z"
          fill="var(--cds-color-pink-300)"
        />
        <path
          className="sparkle"
          id="med-pink-shine-1"
          d="M39.5919 252.527L60.0428 241L43.6821 256.617L48.1441 272.234L39.9638 260.335L21.0002 264.797L34.3863 255.873L24.7186 243.231L39.5919 252.527Z"
          fill="var(--cds-color-pink-300)"
        />
        <path
          className="sparkle"
          id="med-pink-shine-2"
          d="M191.235 324.019L168.553 310.921L186.699 328.667L181.75 346.414L190.823 332.893L211.855 337.963L197.009 327.822L207.731 313.456L191.235 324.019Z"
          fill="var(--cds-color-pink-300)"
        />

        <g id="Plant">
          <path
            id="plant-base"
            d="M6.57713 13.9621C-4.53522 15.4534 1.22538 5.92448 5.49473 0.973633H54.9833C55.765 1.47473 57.6171 3.07825 58.7716 5.48352C60.2148 8.49012 56.0055 9.51236 52.578 10.8954C49.1505 12.2784 50.293 12.9399 52.9388 16.0667C58.952 23.1623 53.6002 26.0486 50.293 26.0486C46.9857 26.0486 41.3935 22.5008 39.349 22.2603C37.3045 22.0198 36.913 27.1126 31.2797 32.765C25.1283 38.9372 6.99804 43.547 6.93791 38.977C6.87778 34.407 19.746 23.2826 23.9552 17.3295C28.1645 11.3764 20.4676 12.098 6.57713 13.9621Z"
            fill="var(--cds-color-blue-100)"
          />
          <g id="stem-and-leaves">
            <path
              id="stem"
              d="M37.7505 19.7284C41.7822 27.7503 49.2222 53.171 46.7283 90.6786"
              stroke="var(--cds-color-blue-100)"
              strokeWidth="2"
            />
            <path
              className="leaf"
              id="leaf-l1"
              d="M45.0589 47.9C38.1855 49.7782 24.4068 54.4777 24.2789 58.2501C24.119 62.9655 36.5071 60.0883 45.0589 47.9Z"
              fill="var(--cds-color-blue-100)"
            />
            <path
              className="leaf"
              id="leaf-l2"
              d="M46.5642 60.4488C38.6521 62.4533 22.9232 68.2124 22.9232 74.067C22.9232 81.8307 40.8687 66.2716 46.5642 60.4488Z"
              fill="var(--cds-color-blue-100)"
            />
            <path
              className="leaf"
              id="leaf-l3"
              d="M47.5315 71.6834C39.623 74.2894 23.8062 81.3473 23.8062 88.7309C23.8062 97.9604 34.8274 93.7257 47.5315 71.6834Z"
              fill="var(--cds-color-blue-100)"
            />
            <path
              className="leaf"
              id="leaf-l4"
              d="M35.696 101.164C35.696 96.8637 43.4415 88.8033 47.3143 85.3105C46.1199 89.7081 43.351 99.3068 41.8309 102.521C39.9307 106.538 35.696 106.538 35.696 101.164Z"
              fill="var(--cds-color-blue-100)"
            />
            <path
              className="leaf"
              id="leaf-r1"
              d="M44.5397 43.3138C52.9232 42.1542 69.85 40.9072 70.4888 45.1959C71.2873 50.5568 48.1897 45.7661 44.5397 43.3138Z"
              fill="var(--cds-color-blue-100)"
            />
            <path
              className="leaf"
              id="leaf-r2"
              d="M66.0439 56.6557C60.1462 55.1904 50.1549 55.5262 45.8965 55.8772C49.6208 58.1056 58.2872 62.4526 63.1593 62.013C69.2493 61.4635 73.4162 58.4872 66.0439 56.6557Z"
              fill="var(--cds-color-blue-100)"
            />
            <path
              className="leaf"
              id="leaf-r3"
              d="M66.1255 69.2961C61.6957 68.1386 51.5861 66.5537 46.9325 66.4005C50.0405 69.979 61.6408 76.3811 66.9266 76.3811C73.4413 76.3811 72.4847 70.9578 66.1255 69.2961Z"
              fill="var(--cds-color-blue-100)"
            />
            <path
              className="leaf"
              id="leaf-r4"
              d="M74.1698 87.7675C68.2896 83.3105 52.9619 78.8045 46.704 77.2439C51.1984 86.0455 63.0495 94.4396 71.1875 94.4396C75.6356 94.4396 81.52 93.3387 74.1698 87.7675Z"
              fill="var(--cds-color-blue-100)"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
);

export default NotFoundSvg;
